var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcWarning = function SvgIcWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC01E",
    d: "M14.313 5.967c.75-1.29 2.624-1.29 3.375 0l10.548 18.132c.75 1.289-.188 2.9-1.688 2.9H5.452c-1.5 0-2.438-1.611-1.688-2.9zM16 21.557a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-11.078c-.69 0-1.25.472-1.25 1.053v7.895c0 .581.56 1.052 1.25 1.052s1.25-.471 1.25-1.052v-7.895c0-.581-.56-1.053-1.25-1.053"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 20.48c-.69 0-1.25-.472-1.25-1.053v-7.895c0-.581.56-1.053 1.25-1.053s1.25.472 1.25 1.053v7.895c0 .581-.56 1.052-1.25 1.052m0 4.078a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
  })));
};
export default SvgIcWarning;